var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeClockColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c5e4fa",
    d: "M1 13H55V53H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3f2ff",
    d: "M34.11 53L55 32.11 55 14 52.21 14 13.21 53 34.11 53zM1.29 53L9.64 53 48.64 14 40.29 14 1.29 53zM1 49.71L36.71 14 32.75 14 1 45.75 1 49.71z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 6,
    x: 1,
    y: 7,
    fill: "#acb7d0",
    rx: 2,
    ry: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M51 35A12 12 0 1 0 51 59A12 12 0 1 0 51 35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M56,35V9a3,3,0,0,0-3-3H3A3,3,0,0,0,0,9V51a3,3,0,0,0,3,3H40.06A13,13,0,1,0,56,35ZM2,9A1,1,0,0,1,3,8H53a1,1,0,0,1,1,1v3H2ZM3,52a1,1,0,0,1-1-1V14H54V34.36A13,13,0,0,0,39,52Zm48,6A11,11,0,1,1,62,47,11,11,0,0,1,51,58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M52 46.59V40a1 1 0 0 0-2 0v7a1 1 0 0 0 .29.71l5 5a1 1 0 0 0 1.41-1.41zM16 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 16 46zM11 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 11 46zM6 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 6 46zM21 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 21 46zM26 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 26 46zM31 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 31 46zM36 46a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V47A1 1 0 0 0 36 46zM19 22h4a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2zM27 22H44a1 1 0 0 0 0-2H27a1 1 0 0 0 0 2zM19 30H44a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2zM34 36H19a1 1 0 0 0 0 2H34a1 1 0 0 0 0-2zM10.29 23.71a1 1 0 0 0 1.41 0l4-4a1 1 0 0 0-1.41-1.41L11 21.59 9.71 20.29a1 1 0 0 0-1.41 1.41zM10.29 31.71a1 1 0 0 0 1.41 0l4-4a1 1 0 0 0-1.41-1.41L11 29.59 9.71 28.29a1 1 0 0 0-1.41 1.41zM11 40a1 1 0 0 0 .71-.29l4-4a1 1 0 0 0-1.41-1.41L11 37.59 9.71 36.29a1 1 0 0 0-1.41 1.41l2 2A1 1 0 0 0 11 40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockColored);
export default __webpack_public_path__ + "static/media/timeClockColored.811aa61d0f812e2bedc40acf3a6adcd4.svg";
export { ForwardRef as ReactComponent };